define('models/zendesk/CategoryModel',['underscore','ObjectModel','LocalStorage','app', 'UrlFactory'],
    function (_,ObjectModel,LocalStorage,app,UrlFactory) {
    //
    // Model Zendesk Category
    //

    var categoriesIcons;

    return ObjectModel.extend({

        name:'ZendeskCategoryModel',
        idAttribute:'id',

        isDirect:function(){
            // est-ce que la catégorie utilise des sous-catégories ?
            switch(''+this.id){
                case app.c('_ZENDESK_GROUP_OTHER_' , '') :
                case app.c('_ZENDESK_GROUP_PRESS_' , '') :
                    return true;
                    break;
            }
            return false;
        },
        getUrl: function () {
            var model = this,
                isDirect = model.isDirect(),
                url = UrlFactory.getUrl('supportCenterResource', {type: 'category', id: model.id});
            // gestion du lien direct
            if(isDirect){
                var section = model.getSections().first();
                if(section){
                    url = section.getUrl();
                }
            }

            return  url;
        },
        getName: function(){
            return this.get('name');
        },
        getSections:function(){
            return _(this.collection.supportCenter.getSections().where({category_id:this.id}));
        },
        getOrderSections:function(isComplete){
            return _(this.collection.supportCenter.getSections().where({category_id:this.id})).filter(function(section){
                return section.isOrder(isComplete);
            });
        },
        getIcon:function(){
            categoriesIcons = categoriesIcons || JSON.parse(app.c('_ZENDESK_CATEGORIES_ICONS_',"{}"));
            return this.id in categoriesIcons ? 'icon-' + categoriesIcons[this.id] : 'icon-customer-service';
        }

    })
});
